import { identity } from 'ramda';

import { hasValue } from '../../util';

export type Formatter = (value: any) => any;

export const defaultFormatter = (value) => hasValue(value) ? identity(value) : null;
